import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getOpenBoardTakeOnStyles = (theme: Theme) =>
  StyleSheet.create({
    /** Covers the board while the challenge and its fixtures load, before the sheet slides up. */
    loading: {
      ...StyleSheet.absoluteFillObject,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.background.overlay,
    },
  });
